import styled from "styled-components";
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const PanicButtonTooltipWrapperBox = styled.div`
    position: relative;
    display: none;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    padding-top: 6px !important;

    &::before{
        content: "";
        position: absolute;
        display: none;
        top: 0;
        width: 12px;
        height: 12px;
        background-color: white;
        transform: rotate(45deg);
    }

    &.${ACTIVE} {
        display: flex;
        &::before{
            display: block;
        }
    }
`
